import BaseService from '@/services/BaseService'
import UserMIREO from '@/models/userMireo'
import User from '@/models/userCSV'

export class UserMireoService extends BaseService<UserMIREO> {
  constructor() {
    super('substitutes/')
  }

  public async search(filter: string): Promise<UserMIREO[]> {
    const result = await this.instance.get<UserMIREO[]>(
      this.resourcePath + 'search/',
      {
        params: {
          filter,
        },
      },
    )
    return result.data
  }

  public async updateMireoMask(mask: string, username: string): Promise<string[]> {
    const result = await this.instance.post(
      this.resourcePath + 'change-email-mireo/',
      {
        mask,
        username,
      },
    )
    return result.data
  }

  public async getMireoUsersFromEstablishment(
    establishmentId: string,
  ): Promise<UserMIREO[]> {
    const result = await this.instance.get<UserMIREO[]>(
      this.resourcePath + 'for-school/',
      {
        params: {
          establishmentId,
        },
      },
    )
    return result.data
  }

  public async getDetails(ad_personne_id: number | string): Promise<any> {
    const result = await this.instance.get(
      this.resourcePath + ad_personne_id + '/details/',
    )
    return result.data
  }

  public async extend(
    ad_personne_id: number,
    date: string,
    username: string,
    schoolId: string,
  ): Promise<any> {
    const result = await this.instance.put(
      this.resourcePath + ad_personne_id + '/extend/',
      { date, username, schoolId },
    )
    return result.data
  }

  public async startMission(
    ad_personne_id: number,
    date: string,
    username: string,
    schoolId: string,
  ): Promise<any> {
    const result = await this.instance.put(
      this.resourcePath + ad_personne_id + '/start/',
      { date, username, schoolId },
    )
    return result.data
  }

  public async endMission(
    ad_personne_id: number,
    username: string,
    schoolId: string,
  ): Promise<any> {
    const result = await this.instance.put(
      this.resourcePath + ad_personne_id + '/end/',
      { username, schoolId },
    )
    return result.data
  }

  public async resetUserPassword(account: UserMIREO, schoolId: string) {
    const result = await this.instance.post(
      this.resourcePath + 'reset-password/',
      {
        account,
        schoolId,
      },
    )
    return result.data
  }
}

export default new UserMireoService()
